"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _StepperStep = _interopRequireDefault(require("./StepperStep"));

var _style = _interopRequireDefault(require("./style"));

var _ThemeProvider = require("../ThemeProvider");

var _propTypes = _interopRequireDefault(require("prop-types"));

var Stepper = function Stepper(_ref) {
  var totalSteps = _ref.totalSteps,
      currentStep = _ref.currentStep,
      classes = _ref.classes,
      _ref$css = _ref.css,
      css = _ref$css === void 0 ? {} : _ref$css;
  var stepElements = [];

  for (var i = 0; i < totalSteps; i++) {
    stepElements.push( /*#__PURE__*/_react["default"].createElement(_StepperStep["default"], {
      index: i,
      key: i,
      steps: totalSteps,
      currentStep: currentStep
    }));
  }

  var style = {
    width: currentStep / (totalSteps - 1) * 100 + '%',
    maxWidth: '100%'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Stepper,
    style: css
  }, /*#__PURE__*/_react["default"].createElement("nav", null, /*#__PURE__*/_react["default"].createElement("i", {
    style: style
  }), stepElements));
};

Stepper.propTypes = {
  currentStep: _propTypes["default"].number.isRequired,
  totalSteps: _propTypes["default"].number.isRequired,
  classes: _propTypes["default"].object.isRequired,
  css: _propTypes["default"].object
};
var ThemedStepper = (0, _ThemeProvider.withStyles)(_style["default"])(Stepper);
var _default = ThemedStepper;
exports["default"] = _default;
//# sourceMappingURL=Stepper.js.map